import { h } from "@stencil/core";
import { PrefillData } from "../../../api/publicApi/createCase";
import { FormStore } from "./form-store";
import { ApiStore } from "../api-store";

interface MachineSelectProps {
    t: (key: string) => string;
    prefillData: PrefillData | null;
    formStore: FormStore;
    apiStore: ApiStore;
}

export const MachineSelect = ({ t, prefillData, apiStore, formStore }: MachineSelectProps) => {
    const { machines } = apiStore.state;
    return (
        <ux-select
            required
            label={t("field.machine.label")}
            data-validation-required--msg={t("validation.requiredField")}
            name="productNo"
            onUxChange={(event) => {
                const machine = machines.find(({ assetId }) => assetId === event.detail.value);
                if (machine) {
                    formStore.state.selectedMachineTechnology = machine.technologyId;
                    return;
                }
                // eslint-disable-next-line no-console
                console.error(`Machine with id ${event.detail.value} not found`);
            }}
            disabled={prefillData?.productData?.assetId}
        >
            <option value="" selected={!prefillData?.productData?.assetId} disabled>
                {t("select.placeholder")}
            </option>
            {machines.map((machine) => (
                <option
                    key={machine.assetId}
                    value={machine.assetId}
                    selected={machine.assetId === prefillData?.productData?.assetId}
                >
                    {machine.assetName} ({machine.assetId})
                </option>
            ))}
        </ux-select>
    );
};
